/**
 * La voix d'un participant sur sa vignette : une fente que l'écran remplit (weekly du 03/11, W1).
 *
 * Les barres bougent dix fois par seconde. Lues dans l'état de la salle, elles redessineraient tout
 * l'écran du live à ce rythme ; passées en prop d'organisme en organisme, elles referaient de même
 * chaque pellicule et chaque mosaïque. L'écran pose donc UNE fonction au-dessus de sa page, et chaque
 * vignette demande la voix de son participant : seul l'élément rendu (un composant des ports qui lit
 * le niveau de sa piste) se redessine au rythme de la voix.
 *
 * Sans fournisseur, aucune vignette n'a de voix : les stories, et les écrans qui n'en veulent pas.
 */
import { createContext, type ReactNode, useContext } from "react"

/** La voix du participant `participantId` (son id de vignette), à la hauteur `size` si elle est dite, ou rien. */
export type VoiceSlot = (participantId: string, size?: number) => ReactNode

export const VoiceSlotContext = createContext<VoiceSlot | null>(null)

/**
 * La voix d'une vignette, lue dans la fente. Un composant à part : la tuile, elle, reste sans crochet, et
 * seule la ligne de son nom se relit quand l'écran change de fente.
 */
export function TileVoice({ participantId, size }: { participantId: string; size?: number }): ReactNode {
    const slot = useContext(VoiceSlotContext)
    return slot?.(participantId, size) ?? null
}
